import { concat } from "rxjs";

export const labels = {
    onsite: "In-person",
    online: "On-line",
    loginPopUpHeading: "For the optimal experience, we prefer you login when registering for an event.",
    loginButton: "Login or Create an Account",
    continueAsGuest: "Continue as a Guest",
    selectChurchAccount: "Today I'm Registering For:",
    submit: "Submit",
    cancel: "Cancel",
    backToEvents: "Back to Events",
    backtoAttendees: "Back to Attendees",
    event: "Event",
    perPerson: "/person",
    perStudent: "/student",
    perTeam: "/team",
    free: "Free",
    export: "Export",
    sendEmail: "Send Email",
    paid: "Paid",
    pending: "Pending",
    individual: "Individual",
    student: "Student",
    group: "Group",
    sitewide: "Sitewide",
    view: "View",
    name: "Name",
    email: "Email",
    foodPreference: "Food Preference",
    allergies: "Allergies",
    church: "Church",
    eventTrack: "Event Track",
    awanaRole: "Awana Role",
    city: "City",
    timezone: "Timezone",
    state: "State",
    churchRole: "Church Role",
    purchaserName: "Purchaser Name",
    purchaserEmail: "Purchaser Email",
    orderId: "Order Id",
    braintreeToken: "Braintree Token",
    ticketAmount: "Ticket Amount",
    mediaReleaseConsent: "Media Release Consent",
    teamAttendance: "Team Attendance",
    userType: "User Type",
    couponApplied: "Coupon Applied",
    attendanceType: "Attendance Type",
    ticketType: "Ticket Type",
    payment: "Payment",
    attendance: "Attendance",
    registrationDate: "Registration Date",
    cancelledOn: "Cancelled On",
    cancelledBy: "Cancelled By",
    yes: "Yes",
    no: "No",
    guest: "Guest",
    loggedIn: "Logged In",
    notApplicable: "N/A",
    noResultsFound: "No Results Found",
    apply: "Apply",
    download: "Download",
    emailRequired: "Please enter the email address.",
    validEmailRequired: "Please enter a valid email address.",
    emailLengthInfo: "Email can't be more than 50 characters",
    firstName: "First Name",
    validFirstNameRequired: "Please enter a valid first name.",
    lastName: "Last Name",
    validLastNameRequired: "Please enter a valid last name.",
    validAllergies:"Please enter allergies max 100 characters.",
    selectChurchRole: "Select Church Role",
    selectAwanaRole: "Select Awana Role",
    awanaRoleRequired: "Please select the Awana Role.",
    selectCountryCode: "Select Country Code",
    validPhoneRequired: "Please enter a valid phone number.",
    selectEventTrack: "Select Event Track",
    validEventTrackRequired: "Please select an event track.",
    selectFoodPreference: "Select Food Preference",
    pageDoesNotExist: "Oops, it seems that this page does not exist.",
    attendees: "Attendees",
    back: "Back",
    edit: "Edit",
    description: "Description",
    specialNotes: "Special Notes",
    eventSpeakers: "Event Speakers",
    details: "Details",
    regDateAndTime: "Registration Date & Time",
    eventPlatform: "Event Platform",
    eventStatus: "Event Status",
    visible: "Visible",
    private: "Private",
    location: "Location",
    eventCapacity: "Event Capacity",
    foodOptions: "Food Options",
    paymentOptions: "Payment Options",
    team: "Team",
    eventHosts: "Event Hosts",
    cancellationPolicy: "Cancellation Policy",
    preEventMaterials: "Pre-Event Materials",
    postEventMaterials: "Post-Event Materials",
    coupons: "Coupons",
    type: "Type",
    available: "Available",
    max: "Max",
    exp: "Exp",
    or: "OR",
    firstPage: "First Page",
    lastPage: "Last Page",
    previousPage: "Previous Page",
    nextPage: "Next Page",
    close: "Close",
    purchaser: "Purchaser",
    quantity: "Quantity",
    price: "Price",
    subtotal: "Subtotal",
    tax: "Tax",
    paymentMethod: "Payment Method",
    creditCard: "Credit Card",
    total: "Total",
    save: "Save",
    questions: "Questions",
    time: "Time",
    firstNameRequired: "Please enter your first name.",
    validFirstName: "Please enter your first name between 2 and 50 characters.",
    lastNameRequired: "Please enter your last name.",
    validLastName: "Please enter your last name between 2 and 50 characters.",
    eventInfo: "Event Information",
    addAttendee: "Add Attendees",
    backToEditEvent: "Back To Edit Event",
    delete: "Delete",
    previous: "Previous",
    next: "Next",
    selectRegion: "Select Region",
    selectCountry: "Select Country",
    selectState: "Select State",
    validNumber: "Please enter a valid number without a comma or decimal point.",    
    selectTimezone: "Select Timezone",
    eventTracks: "Event Tracks",
    foodPreferences: "foodPreferences",
    country: "Country",
    countryWithCode:"Country/Country Code",
    register: "Register",
    validCaptcha: "Please verify through Captcha",
    contactFullName: "Contact Full Name",
    contactEmail: "Contact Email",
    qr_reg_url: "QR Code",
    duplicateEvent: "Duplicate Event",
    eventAnalytics: "Event Analytics",
    phone: "Phone Number",
    validNoteLength: "Please enter note less than or equal to 128 characters",
    sortBy: "Sort By",
    sortByOption1: "Date: Upcoming",
    sortByOption2: "Date: Newest",
    sortByOption3: "Date: Oldest",
    sortByOption4: "Name: Ascending",
    sortByOption5: "Name: Descending",
    filter: "Filter",
    eventFilter1: "Hide Past Events",
    eventFilter2: "Hide Future Events",
    continue: "Continue",
    confirm: "Are you sure you want to do this?"
}

export const attendeesListingLabels = {
    registeredAttendees: "Registered Attendees",
    scanQr: "Scan QR Code",
    viewCancellations: "View Cancellations",
    viewAttendees: "View Attendees",
    cancelRegistration: "Cancel Registration",
    attendanceReport: "Attendance Report | CSV",
    eventPrepReport: "Event Prep Report | CSV",
    paymentsReport: "Payments Report | CSV",
    mediaReleaseReport: "Media Release Report | CSV",
    customReport: "Custom Report | CSV",
    selectReport: "Select Report Type:",
    hostReport: "Host Report",
    eventSupporterReport: "Event Supporter Report",
    eventEditorReport: "Event Editor Report",
    financeTeamReport: "Finance Team Report",
    partnerCareReport: "Partner Care Report",
    markPayment: "Mark Payment",
    markAttendance: "Mark Attendance",
    switchAttendanceType: "Switch Attendance Type",
    clearFilters: "Clear Filters",
    scheduleNotification: "Schedule Notification",
    resendOrderConfirmations: "Resend Order Confirmations",
    selectPayment: "Select Payment",
    selectTicketType: "Select Ticket Type",
    selectAttendanceType: "Select Attendance Type",
    selectCouponApplied: "Select Coupon Applied",
    selection: "Selection",
    showingOne: "Showing 1 of",
    pages: "pages",
    rows: "Rows",
    first: "First",
    last: "Last",
    actions: "Actions",
    absent: "Absent",
    present: "Present",
    none: "None",
    updateAttendance: "Update Attendance Status",
    changeAttendanceType: "Change Attendance Type",
    updatePaymentStatus: "Update Payment Status",
    updatePaymentWarningMessage: "Please note that only attendees that have opted to 'Pay To Host' during registration will be updated.",
    selectedAttendees: "Selected Attendees",
    cancelRegistrationCheck: "Are you sure you want to cancel this registration?",
    resendReceipts: "Order confirmation receipts will be sent to the purchasers of all the selected orders.",
    resendTickets: "Please select how you want tickets to be resent.",
    resendToPurchaser: "Send group tickets to Purchaser",
    resendToPurchaserSubText: "(For In-person group registrations, an email containing all selected tickets for the group will be sent to the purchaser)",
    resendToAttendee: "Send to all Attendees",
    resendToAttendeeSubText: "(In-person tickets will be sent to all selected attendees)",
    resendEmails: "Send",
    selectFieldsToExport: "Select Fields To Export",
    all: "All",
    mail: "Mail",
    markAtd: "Mark Atd",
    markPymt: "Mark Pymt",
    cancelReg:"Cancel Reg",
    editAttendee: "Edit Attendee",
    saveAttendee: "Save Attendee",
    transferAttendee: "Transfer Ticket",
    from: "From",
    to: "To",
    transfer: "Transfer",
    notes: "Notes",
    ticketTransfered: "This ticket will be transfered",    
    cameraScan: "Camera App - Scan Here",
    attendeeDetails: "Attendee Details",
    unmark: "UNMARK",
    markAsAttend: "MARK AS Attend",
    invalidQr: "QR code is not valid",
    invalidQrMessage: "The QR Code that you scanned is invalid or expired, kindly scan correct QR Code for the Event",
    tryAgain: "Try again",
    defaultView: "Set as my default view",
}

export const eventDetailsLabels = {
    takeSurvey: "Take Survey",
    comingSoon: "Coming Soon...",
    eventRegPrice: "Event Regular Price",
    eventVarPricing: "Event Variable Pricing",
    expiresOn: "Exp On",
    publishedDate: "Published Date"
}

export const faqLabels = {
    faq: "Frequently Asked Questions",
    categories: "Categories",
    general: "General",
    groupRegistration: "Group Registration",
    eventSearch: "Event Search"
}

export const modifyConfEmailLabels = {
    modifyRegConfEmail: "Modify Registration Confirmation Email",
    customMessage: "Custom Message",
    validMessageLength: "Please enter a custom message between 2 and 1000 characters",
    thankYouForReg: "Thank you for registering for the following event:",
    addToCalendar: "Add to Calendar",
    testPurchaserEmail: "purchaser@awana.org",
    attendeeName: "Attendee Name",
    testAttendeeEmail: "attendee@awana.org",
    testOrderId: "O123456789",
    awanaSignature: "- the Awana team",
    additionalHelp: "For additional help and support:",
    contactUs: "Contact our team at. (866) 292-6227 /",
    customerCareEmail: "customercare@awana.org",
    copyrightYear: "2022 by Awana",
    copyright: "Clubs International. All rights reserved.",
    copyrightMessage:"The text and images of this website may not be copied for distribution in any way, directly or indirectly, without express written permission from Awana Clubs International otherwise stated or granted. US Only"
}

export const performSurveyLabels = {
    aboutEvent: "About Event",
    rateSatisfaction: "Rate your satisfaction level with the following aspects of events:",
    surveySettingWarning: "Please check and update Live survey settings"
}

export const sendEmailLabels = {
    backToAttendees: "Back to Attendees",
    eventInformation: "Event Information",
    numberOfRecipients: "Number of Recepients",
    emailScheduled: "This email is scheduled to be sent on",
    sendDate: "Send Date",
    invalidTime: "Please enter scheduled time greater than the current time and less than the start time for the event.",
    subject: "Subject",
    message: "Message",
    attachments: "Attachments",
    previewAndSend: "Preview & Send",
    previewAndSchedule: "Preview & Schedule",
    preview: "Preview",
    schedule: "Schedule",
    send: "Send",
    deleteConfirmation: "Are you sure you want to delete this scheduled notification?"
}

export const speakersLabels = {
    columnsPerRow: "Columns Per Row",
    addRow: "ADD ROW",
    deleteConfirmation: "Are You Sure You Want To Delete This Speaker Block?",
    deleteMessage: "Please note that you will no longer have access to the column and its contents once deleted.",
    addColumn: "Add Column",
    validNameRequired: "Please enter a name between 2 and 100 characters.",
    validDescriptionRequired: "Please enter a column description of 2 or more characters."
}

export const createEventLabels = {
    createNewEvent: "Create New Event",
    editEvent: "Edit Event",
    eventDetails: "Event Details",
    locationAndTime: "Location & Time",
    pricing: "Pricing",
    contactAndFinanceInfo: "Contact & Financial Info",
    contactInfo: "Contact Info",
    financeInfo: "Financial Routing Options",
    financeInfoSubTitle: "Proceeds from this event should be associated to the following GAU",
    myDefaultGau: "My Default GAU",
    otherGau: "Other GAU",
    eventPrep: "Event Prep",
    summary: "Summary",
    eventTitle: "Event Title",
    eventTitleRequired: "Please enter an event title.",
    eventTitleLength: "Please enter an event title between 2 and 100 characters.",
    eventTitleFormat: "Please enter an event title without slashes.",
    createCustomUrl: "Create Custom URL",
    customUrl: "Custom URL",
    createLink: "Create Link",
    enterCustomUrl: "Please enter the Custom URL.",
    enterAlphanumeric: "Please enter text, numbers alphanumeric to create event link",
    clickForCustomUrl: "Please click the CREATE LINK button to create Custom URL.",
    customUrlLength: "Custom URL can be minimum of 2 and maximum of 80 characters only.",
    urlAlreadyExists: "Already in use, please use another URL name.",
    eventCategory: "Event Category",
    select: "Select",
    email: "Email",
    eventCategoryRequired: "Please select an event category.",
    selectEventIcon: "Select Event Icon",
    eventIconRequired: "Please select an event icon.",
    eventType: "Event Type",
    paidEvent: "Paid Event",
    freeEvent: "Free Event",
    displayEvent: "Display Event",
    eventGAU: "Event GAU",
    validGAURequired: "Please enter a valid GAU.",
    manageSpeakers: "Manage Speakers",
    descriptionRequired: "Please enter an event description.",
    descriptionLength: "Please enter an event description between 2 and 1000 characters.",
    specialNotes: "Special Notes",
    specialNotesLength: "Please enter special notes for this event between 2 and 1000 characters.",
    both: "Both",
    eventLink: "Event link",
    eventLinkRequired: "Please enter an online url",
    eventVenue: "Event Venue",
    eventVenueRequired: "Please enter an event venue.",
    eventVenueLength: "Please enter an event venue under 100 characters.",
    isChurchInfoRequired: "Is Church Info Required?",
    isChurchInfoMandatory: "Is Church Info Mandatory?",
    mandatory: "Mandatory",
    optional: "Optional",
    isChurchRoleRequired: "Is Church Role Required?",
    isChurchRoleMandatory: "Is Church Role Mandatory?",
    isAwanaRoleRequired: "Is Awana Role Required?",
    isAwanaRoleMandatory: "Is Awana Role Mandatory? ",
    isPurchaserLocationRequired: "Is purchaser's location info required?",
    isPurchaserStateCityMandatory: "Is purchaser's state/city mandatory?",
    askQuestion: "Ask question on registration form?",
    question: "Question",
    options: "Options",
    isQuestionMandatory: "Is question mandatory?",
    responseType: "Response Type",
    shortAnswer: "Short Answer",
    dropdown: "Dropdown",
    addQuestion: "Add Question",
    pleaseEnterQuestion: "Please enter the Question.",
    questionLength: "Please enter the question between 2 and 250 characters.",
    questionNoSpecialCharacters: "Please enter the question without special characters.",
    selectResponseType: "Select Response Type",
    responseTypeRequired: "Please select the response type.",
    add: "Add",
    optionsRequired: "Please enter the options.",
    optionsLength: "Please enter the option between 2 and 50 characters.",
    optionsNoSpecialCharacters: "Please enter the options without special characters.",
    isPhoneRequired: "Is the phone number needed?",
    isEventHostSelectionRequired: "Is Event Host selection required?",
    addEventTracks: "Add Event Tracks",
    eventTrackOptions: "Event Track Options",
    eventTracksNeeded: "Please enter event tracks for attendees.",
    eventTracksLength: "Please enter an event track with at least 2 characters.",
    displayEventHost: "Should display the event Host?",
    displayCapacity: "Should display the available capacity?",
    capacity: "Capacity",
    capacityRequired: "Please enter an event capacity.",
    capacityGreaterThanZero: "Please enter a capacity greater than 0.",
    capacityLength: "Please enter an event capacity larger than the amount of attendees already registered.",
    region: "Region",
    regionRequired: "Please select a region.",
    countryRequired: "Please select a country.",
    addressLine1: "Address Line 1",
    addressRequired: "Please enter an address.",
    addressLine2: "Address Line 2",
    city: "City",
    cityRequired: "Please enter a city.",
    state: "State/Province",
    stateRequired: "Please enter a state.",
    zipcode: "Zip Code/Postal Code",
    zipcodeRequired: "Please enter a zipcode/postal code.",
    eventStartDate: "Event Start Date",
    startDateRequired: "Please enter an event start date.",
    eventEndDate: "Event End Date",
    eventEndDateRequired: "Please enter an event end date.",
    eventEndDateConstraint: "Event end date can't be earlier than the last date to cancel registration.",
    startTimeRequired: "Please enter an event start time.",
    eventEndTimeRequired: "Please enter an event end time.",
    eventEndTimeConstraint: "Please enter an end time greater than the start time for a single day event.",
    timezoneRequired: "Please enter an event timezone.",
    registrationStartDate: "Registration Start Date",
    registrationStartDateRequired: "Please enter an event registration start date.",
    registrationEndDate: "Registration End Date",
    registrationEndDateRequired: "Please enter an event registration end date.",
    startTime: "Start Time",
    registrationStartTimeRequired: "Please enter an event registration start time.",
    endTime: "End Time",
    registrationEndTimeRequired: "Please enter an event registration end time.",
    registrationEndTimeConstraint: "Please enter an end time greater than the start time for a single day event.",
    addFoodPreference: "Add Food Preference Options For Attendees",
    foodPreferenceOptions: "Food Preference Options",
    foodPreferenceOptionsRequired: "Please enter food preference options for attendees.",
    paymentMethodRequired: "Please select one or more payment methods.",
    regularPricing: "Regular Pricing per Person (USD)",
    regularPriceRequired: "Please enter the Regular price for the event.",
    validNumberRequired: "Please enter a valid number without a dollar sign or comma.",
    regularStudentPricing: "Regular Pricing per Student (USD)",
    additionalPricing: "Additional Pricing",
    addTierPricing: "Add Tier Pricing",
    tierPricing: "Tier Pricing",
    onlineTierPricing: "Online Tier Pricing",
    pricingFor: "Pricing for",
    tierPrice: "Tier Price",
    startDateTime: "Start Date & Time",
    endDateTime: "End Date & Time",
    students: "Students",
    selectTiers: "Select Tiers",
    tierCategoryRequired: "Please select the tier category.",
    selectTierPrice: "Select Price for Tier",
    validTierAmount: "Please enter the valid tier amount.",
    tierAmount: "Tier Amount",
    tierAmountRange: "Tier amount should between $1 and less than",
    startDate: "Start Date",
    endDate: "End Date",
    tierStartDateRequired: "Please enter the tier start date.",
    tierStartTimeRequired: "Please enter the tier start time.",
    tierStartTimeAvailability: "Please enter the tier pricing start time based on the availability.",
    expiryDate: "Expiry Date",
    tierEndDateRequired: "Please enter the tier end date.",
    tierEndTimeRequired: "Please enter the tier end time.",
    tierEndTimeAvailability: "Please enter the tier pricing end time based on the availability.",
    updateTierPricing: "Update Tier Pricing",
    addEventCoupons: "Add Event Coupons",
    allCoupons: "Coupon Code",
    print: "Print",
    export: "Export",
    mail: "Mail",
    category: "Coupon Type",
    couponCode: "Coupon Code",
    couponName: "Coupon Name",
    generateRandomCode: "Generate Random Code",
    maxUsage: "Max Usage",
    minGroupSize: "Minimum Group Size",
    discount: "Amount",
    expDateTime: "Exp Date & Time",
    fixed: "Dollar Discount Value",
    percentage: "Percentage Discount Value",
    discountAmount: "Dollar Discount",
    fixedTicketPrice: "Fixed Ticket Price",
    discountAmtRequired: "Please enter the valid coupon discount amount.",
    discountAmountRange: "Discount amount should be between $1 and ",
    discountCategory: "Discount Category",
    groups: "Groups",
    pastors: "Pastors",
    speakers: "Speakers",
    partners: "Partners",
    vip: "VIP",
    donors: "Donors",
    staff: "Staff",
    volunteers: "Volunteers",
    friends: "Friends",
    couponCodeRequired: "Please enter the coupon name",
    couponCodePattern: "Coupon names are limited to 35 characters and may only contain the following: [ A-Z, a-z],  [0-9] , ['_', '-']",
    couponCategoryRequired: "Please select the coupon category",
    maxUsageRequired: "Please enter the valid coupon maximum usage in number.",
    maxUsageRange: "Please enter 1 to ",
    minimumGroupSize: "Minimum Group Size",
    minGroupSizeRange: "Please enter the minimum group size range from 1 to 20 and less than the event capacity.",
    discountInPercentage: "Discount in Percentage",
    discountPercentageRequired: "Please enter the coupon discount percentage.",
    validPercentage: "Please enter a valid coupon discount percentage in number.",
    percentageRange: "Please enter the discount percentage between 1 to 100.",
    expiryDateRequired: "Please enter the coupon expiry date.",
    expiryTime: "Expiry Time",
    expiryTimeRequired: "Please enter the coupon expiry time.",
    couponExpiryRange: "The coupon start and expiry date/time should be between registration start and end date/time.",
    regularTeamPricing: "Regular Pricing per Team (USD)",
    fullName: "Full Name",
    hostDetails: " Host Details",
    nameRequired: "Please enter your name.",
    addCohost: "Add Cohost",
    noAccountsFound: "No account exists in our database with the entered email address.",
    addEventSupporters: "Add Event Supporters",
    addEventEditors: "Add Event Editors",
    cancellationPolicyLength: "Please enter cancellation policy for this event between 2 and 1000 characters.",
    lastDateToCancel: "Last Date to Cancel Registration",
    lastDateToCancelRequired: "Please select a last date to cancel registration.",
    noCancelOrRefund: "No Cancellations or Refunds",
    addEventPrep: "You can add Event Preparation",
    eventPrepAfter: "materials only after the event is created.",
    preEventMaterial: "Pre-Event Material",
    materialEndDateValid: "Please enter an end time greater than the start time for the event material.",
    tagOptional: "Tag (optional):",
    done: "Done",
    browseFiles: "Browse Files",
    files: "Files",
    title: "Title",
    tag: "Tag",
    availability: "Availability",
    postEventMaterial: "Post-Event Material",
    fileTitle: "File Title",
    isMaterialDownloadable: "Is post event material downloadable",
    link: "Link",
    dateAndTime: "Date & Time",
    addCoupon: "Add Coupon",
    updateCoupon: "Update",
    eventVariablePrice: "Event Variable Price",
    collaborators: "Collaborators",
    eventEditors: "Event Editors",
    eventIcon: "Event Icon",
    modifyConfEmail: "Modify Confirmation Email",
    pleaseConfirm: "Please Confirm",
    sendEmailUpdate: "Do you want to send out an email or not for the updated changes?",
    removeQuestions: "Questions will be removed, are you sure to uncheck?",
    couponStartDate: "Start Date",
    couponStartTime: "Start Time",
    setPrice: "Fixed Ticket Price",
    GAUWarning: "Financial Routing Options are not able to be modified when “Event Host selection” is required.  Funds will be allocated based on the event host selected during registration.",
    couponRangeError: "The Coupon End date/time cannot be prior to the Coupon Start date/time."

 }

export const listEventLabels = {
    selectCategory: "Select Category",
    createEvent: "Create Event",
    events: "Events",
    now: "now",
    allEvents: "All Events",
    myEvents: "My Events",
    myDrafts: "My Drafts"
}

export const registerEventLabels = {
    eventRegistration: "Event Registration",
    note: "Note",
    registeringFor: "Registering for",
    purchaserAttendeeInfo: "Purchaser/Attendee Info",
    available: "Available =",
    selectAttendanceTypeMessage: "Please select the Attendance Type",
    selectRegistrationType: "Please select the registration for Individual or Group.",
    numOfAttendees: "Enter number of attendees",
    numOfAttendeesRequired: "Please enter number of attendees.",
    numOfAttendeesLength: "Number of attendees can not be more than 4 digits long.",
    areYouAttending: "Are you attending this event?",
    providePurchaserDetails: "Provide Purchaser Details for Billing/Invoicing",
    phoneNumber: "Phone Number",
    phoneRequired: "Please enter your phone number.",
    yourCity: "Your City",
    yourCityRequired: "Please enter your city name.",
    yourCityLength: "Please enter your city between 2 and 100 characters.",
    yourState: "Your State/Province",
    yourStateRequired: "Please enter your state/province.",
    yourStateLength: "Please enter your state/province between 2 and 100 characters.",
    yourTimezoneRequired: "Please select your timezone",
    churchName: "Church Name",
    churchNameRequired: "Please enter your church name.",
    churchNameLength: "Please enter your church name between 2 and 100 characters.",
    churchCity: "Church City",
    churchCityRequired: "Please enter your church city.",
    churchCityLength: "Please enter your church city between 2 and 100 characters.",
    churchState: "Church State/Province",
    churchStateRequired: "Please enter your church state/province.",
    churchStateLength: "Please enter your church state/province between 2 and 100 characters.",
    churchPostalCode: "Church Postal Code",
    churchPostalCodeRequired: "Please enter your church postal code.",
    churchPostalCodeLength: "Please enter your church postal code between 2 and 100 characters.",
    churchRoleRequired: "Please select the church role.",
    eventHost: "Event Host",
    selectEventHost: "Select Event Host",
    eventHostRequired: "Please select the event host.",
    selectEventTrack: "Select Event Track",
    eventTrackRequired: "Please select an event track.",
    optionRequired: "Please select an option.",
    enterResponse: "Please enter a response between 50 and 300 characters.",
    addAttendeeInfo: "Add Attendee Info",
    continueToPayment: "Continue to Payment",
    addAttendees: "Add Attendees",
    addAttendee: "Add Attendee",
    attendeeNeeded: "Please add at least one attendee.",
    paymentDetails: "Payments & Billing Details",
    payToHost: "Pay to Host/at door",
    cardNumber: "Card Number",
    cvv: "CVV",
    expirationDate: "Expiration Date",
    billingAddress: "Billing Address",
    billingAddressRequired: "Please enter your billing address.",
    billingAddressLength: "Please enter your billing address between 2 and 100 characters.",
    billingCity: "Billing City",
    billingCityRequired: "Please enter your billing city.",
    billingCityLength: "Please enter your billing city between 2 and 100 characters.",
    billingState: "Billing State",
    billingStateRequired: "Please enter your billing state.",
    billingStateLength: "Please enter your billing state between 2 and 100 characters.",
    billingCountryRequired: "Please select your billing country.",
    billingZipcode: "Billing Zipcode",
    billingZipcodeRequired: "Please enter your billing zipcode.",
    billingZipcodeLength: "Please enter a valid billing zipcode.",
    didReceiveMoney: "Did you receive the money?",
    mediaRelease: "MEDIA RELEASE",
    mediaReleaseConsent: "I understand that at this event, I may be photographed, filmed or interviewed. I agree to allow such photos, video and audio recordings to be freely used for any legitimate purpose by Awana, its representatives and assigns",
    viewCancellationPolicy: "View Cancellation Policy",
    cancellationUntil: "Cancellation Until",
    noncancellable: "This event is non-cancellable and non-refundable",
    yourOrder: "Your Order",
    enterPromoCode: "Enter Promo Code",
    discountApplied: "Discount Applied",
    invalidCoupon: "Invalid Coupon",
    couponError: "Current price is lower than coupon price"
}
